import React from 'react'
import { logEvent } from '../analytics/utils/firebaseUtils'

export interface ModeOption<T extends string> {
	mode: T
	label: string
	rendered?: boolean
}

export interface ModeSwitchProps<T extends string> {
	options: ModeOption<T>[]
	currentMode: T
	onModeChange: (mode: T) => void
	shadow?: boolean
	border?: boolean
	customBackground?: string
	disabled?: boolean
}

const ModeSwitch = <T extends string>({
	options,
	currentMode,
	onModeChange,
	shadow,
	border,
	customBackground,
	disabled,
}: ModeSwitchProps<T>) => {
	return (
		<div
			className={`switch font-semibold gap-1 bg-white dark:bg-surface-dark ${
				customBackground ? customBackground : ''
			} dark:text-brand-secondary-100-dark${
				border ? ' border border-brand-primary-100-light dark:border-brand-primary-100-dark' : ''
			} ${disabled ? 'opacity-50 cursor-wait' : ''} ${shadow ? 'shadow-card' : ''}`}
		>
			{options
				.filter(x => x.rendered === undefined || x.rendered === true)
				.map(({ mode, label }) => (
					<div
						key={mode}
						onClick={() => {
							if (!disabled) {
								logEvent(`click-chart-change-mode`, { value: mode })
								onModeChange(mode)
							}
						}}
						className={`option ${
							currentMode === mode
								? 'selected text-white bg-brand-primary-100-light dark:text-brand-secondary-200-dark dark:bg-brand-primary-100-dark cursor-default'
								: 'text-[#a3a3a3] bg-white dark:bg-[#144448] dark:text-brand-primary-100-dark hover'
						}`}
					>
						{label}
					</div>
				))}
		</div>
	)
}

export default ModeSwitch
